function toggleVideo(e) {
	let thisVideoName =
		"video-" +
		e.id
			.split("-")
			.filter((word) => word !== "play")
			.toString();
	thisVideo = Array.from(document.getElementsByClassName(thisVideoName))[0];
	if (thisVideo.paused) {
		thisVideo.play();
		if (e.toString() !== "[object HTMLVideoElement]") {
			e.querySelector(".pause-button").style.display = "block";
			e.querySelector(".play-button").style.display = "none";
		}
	} else {
		thisVideo.pause();
		if (e.toString() !== "[object HTMLVideoElement]") {
			e.querySelector(".pause-button").style.display = "none";
			e.querySelector(".play-button").style.display = "block";
		}
	}
}
